module.exports = __webpack_public_path__ + "static/media/fracture-instrumental.7d633202.png";